import { render } from "./NobrFix.vue?vue&type=template&id=12bf128f&scoped=true"
const script = {}

import "./NobrFix.vue?vue&type=style&index=0&id=12bf128f&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-12bf128f"]])

export default __exports__